import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WinningPrize } from '../../games/interfaces/game';

@Injectable({
    providedIn: 'root',
})
export class PromotionService {

    public constructor(
      private readonly http: HttpClient,
    ) { }

    public drawWinner(saleId: number, stepId: number): Observable<WinningPrize> {
        return this.http.post<WinningPrize>(`/api/sales/${saleId}/draw-prize`, {
            step_id: stepId,
        });
    }
}
